export const title = {
  h1: {
    size: 8,
    fontStyle: 'normal',
    fontWeight: 300
  },
  h2: {
    // #38294 reduced by 20% (to 4.8rem)
    // #39047 reduced even further (to 4.0rem)
    size: 4.0,
    fontStyle: 'normal',
    fontWeight: 300
  },
  h3: {
    size: 5,
    fontStyle: 'italic',
    fontWeight: 300
  },
  h4: {
    size: 4.5,
    lineHeight: 5.5,
    fontStyle: 'normal',
    fontWeight: 800
  },
  h5: {
    size: 2,
    lineHeight: 3,
    fontStyle: 'normal',
    fontWeight: 300
  },
  h6: {
    size: 1.8,
    lineHeight: 2.5,
    fontStyle: 'italic',
    fontWeight: 300
  },
  group: {
    size: 3,
    lineHeight: 3.4,
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  card: {
    size: 2.5,
    lineHeight: 3.4,
    fontStyle: 'normal',
    fontWeight: 500
  },
  searchItem: {
    size: 4,
    fontStyle: 'normal',
    fontWeight: 500
  },
  mapInfo: {
    size: 4.2,
    lineHeight: 5,
    fontStyle: 'normal',
    fontWeight: 500
  },
  busTypeSelect: {
    size: 3.4,
    lineHeight: 4,
    fontStyle: 'normal',
    fontWeight: 500
  },
  keyvisual: {
    size: 4,
    lineHeight: 4.6,
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  overlayForm: {
    size: 3,
    lineHeight: 1.067,
    fontStyle: 'normal',
    fontWeight: 500
  },
  bussOffers: {
    size: 2.2,
    lineHeight: 2.4,
    fontStyle: 'normal',
    fontWeight: 'bold'
  },
  contentTitle: {
    size: 2.6,
    lineHeight: 3.2,
    fontStyle: 'normal',
    fontWeight: 500
  }
};
